import { CalendarDays } from "lucide-react";

export function toISODate(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function shift(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return toISODate(d);
}

export default function DateNav({ value, onChange }) {
  const today = toISODate();
  const items = [
    { k: shift(-1), l: "Hier", id: "hier" },
    { k: today, l: "Aujourd'hui", id: "aujourdhui" },
    { k: shift(1), l: "Demain", id: "demain" },
  ];
  const current = value || today;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="date-nav">
      {items.map((it) => (
        <button
          key={it.k}
          onClick={() => onChange(it.k)}
          data-testid={`datenav-${it.id}`}
          className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
            current === it.k ? "bg-[#00E676] text-[#04180a]" : "bg-[#131F17] text-[#A1B5A8] hover:text-white border border-[#00E676]/15"
          }`}
        >
          {it.l}
        </button>
      ))}
      <label className="flex items-center gap-2 bg-[#131F17] border border-[#00E676]/15 rounded-lg px-3 py-2 cursor-pointer">
        <CalendarDays size={16} className="text-[#00E676]" />
        <input
          type="date"
          value={current}
          onChange={(e) => e.target.value && onChange(e.target.value)}
          data-testid="datenav-input"
          className="bg-transparent text-white text-sm focus:outline-none"
          style={{ colorScheme: "dark" }}
        />
      </label>
    </div>
  );
}
